var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCCNSW)?_c('forgot-ccnsw'):(_vm.isStatewide)?_c('forgot-stw'):_c('forgot-default')
}
var staticRenderFns = []

export { render, staticRenderFns }